export default __webpack_public_path__ + "89769cf22abcf91f6e1e8a94e266e2c8.png";